import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { api, API } from "../lib/api";
import { CraftLogo, LangSwitcher, CraftFooter } from "../components/Shared";
import { useLang } from "../i18n";

export default function MyLoyalty() {
  const { code } = useParams();
  const { t, L } = useLang();
  const [data, setData] = useState(null);
  const [err, setErr] = useState(false);
  useEffect(() => {
    api.get(`/public/loyalty/${code}`).then((r) => setData(r.data)).catch(() => setErr(true));
  }, [code]);
  return (
    <div className="min-h-screen bg-[#FBF3E4]">
      <div className="max-w-[430px] mx-auto min-h-screen flex flex-col">
        <div className="flex items-center justify-between px-5 pt-5 pb-3"><CraftLogo /><LangSwitcher /></div>
        <div className="px-5 flex-1 space-y-4">
          {err && <div className="craft-card p-6 text-center font-bold" data-testid="loyalty-not-found">{t("not_found")}</div>}
          {data && (
            <>
              <div className="craft-card p-6 text-center space-y-2">
                <h1 className="font-display font-black text-2xl">{data.first_name || "CRAFT Guest"}</h1>
                <img data-testid="my-qr" src={`${API}/qr/data?text=${data.personal_code}`} alt="QR" className="w-44 h-44 mx-auto rounded-2xl" />
                <div className="font-display font-black text-2xl tracking-widest">{data.personal_code}</div>
                <p className="text-xs text-gray-400">{t("show_staff")}</p>
              </div>
              {(data.programs || []).map((p) => (
                <div key={p.campaign_id} className="craft-card p-5 space-y-2" data-testid="loyalty-program-card">
                  <div className="font-display font-extrabold">{L(p.name)}</div>
                  <div className="flex gap-1.5">
                    {Array.from({ length: p.required }).map((_, i) => (
                      <div key={i} className={`h-2.5 flex-1 rounded-full ${i < p.count ? "bg-[#FEBC10]" : "bg-gray-200"}`} />
                    ))}
                  </div>
                  <div className="text-sm font-bold text-gray-600">{t("visits_of", { a: p.count, b: p.required })}</div>
                  {p.reward_status === "available" && <div className="bg-green-50 text-green-700 rounded-xl p-3 text-sm font-bold">🎁 {L(p.reward?.name)} — {t("reward_ready")}</div>}
                </div>
              ))}
            </>
          )}
        </div>
        <CraftFooter />
      </div>
    </div>
  );
}
